import styled, { css } from 'styled-components';
import { Color } from 'src/utils/theme';

export const PronunciationViewWrapper = styled.div<{ $background?: Color | 'default' | 'none' }>(
  ({ theme, $background = 'default' }) => css`
    display: flex;
    justify-content: center;
    align-items: center;

    ${
      $background !== 'none' &&
      css`
        background-color: ${$background === 'default' ? theme.co.tertiary98 : theme.co[$background]};
      `
    };

    @media (min-height: ${theme.sz.xl}) {
      align-items: start;
    }
  `,
);
